<div class="d-flex justify-content-center align-items-center gap-3 w-100">
  <ng-content select="[step-index]"></ng-content>

  <div class="d-flex align-items-center gap-2 w-100 flex-fill overflow-hidden">
    <p class="truncate">{{ step.label }}</p>
    <p *ngIf="step.requirementType === EngagementTaskStatus.OPTIONAL">(Optional)</p>
  </div>
  
  <ng-container *ngIf="step.hasTasksForCurrentUser">
    <ng-container [ngSwitch]="step.status">
      <aiwyn-icon *ngSwitchCase="EngagementStepStatus.INCOMPLETE" name="circle" height="16" width="16"></aiwyn-icon>
  
      <aiwyn-icon
        *ngSwitchCase="EngagementStepStatus.COMPLETE"
        class="engagement-step-complete"
        name="check-circle"
        height="16"
        width="16"
      >
      </aiwyn-icon>
  
      <pill
        *ngSwitchCase="EngagementStepStatus.INVALID"
        color="red"
        [dark]="true"
        size="small"
        value="ACTION REQUIRED"
      ></pill>
  
      <pill
        *ngSwitchCase="EngagementStepStatus.FAILED"
        color="red"
        [dark]="true"
        size="small"
        [value]="ENGAGEMENT_STEP_FAILED_MESSAGE[step.type]"
      ></pill>
    </ng-container>
  </ng-container>
</div>
